export const CHANNEL_TYPES = {
  GROUP: "GROUP",
  DIRECT: "DIRECT",
};

export const CUSTOM_MESSAGE_TYPE = {
  date: 'message.date',
  intro: 'channel.intro',
} as const;
